export const CHAT_ATTACHMENT_MAX_FILES_PER_MESSAGE = 10;
export const CHAT_ATTACHMENT_MAX_TOTAL_SIZE_BYTES = 50 * 1024 * 1024;

export const CHAT_ATTACHMENT_CONTENT_TYPES_BY_EXTENSION = {
  '.pdf': 'application/pdf',
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.gif': 'image/gif',
  '.webp': 'image/webp',
} as const;

export const CHAT_ATTACHMENT_ACCEPT = Object.keys(CHAT_ATTACHMENT_CONTENT_TYPES_BY_EXTENSION).join(
  ','
);

const WEAK_BROWSER_CONTENT_TYPES = new Set(['', 'application/octet-stream', 'binary/octet-stream']);

function getFileExtension(fileName: string) {
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex < 0) {
    return '';
  }

  return fileName.slice(lastDotIndex).toLowerCase();
}

function normalizeContentType(contentType: string) {
  return contentType.split(';')[0]?.trim().toLowerCase() ?? '';
}

export function getChatAttachmentContentType(file: File) {
  const extension = getFileExtension(file.name);
  const expectedContentType =
    CHAT_ATTACHMENT_CONTENT_TYPES_BY_EXTENSION[
      extension as keyof typeof CHAT_ATTACHMENT_CONTENT_TYPES_BY_EXTENSION
    ];

  if (!expectedContentType) {
    return null;
  }

  const normalizedContentType = normalizeContentType(file.type);

  if (WEAK_BROWSER_CONTENT_TYPES.has(normalizedContentType)) {
    return expectedContentType;
  }

  if (normalizedContentType === expectedContentType) {
    return expectedContentType;
  }

  return null;
}

export function formatChatAttachmentSize(sizeBytes: number) {
  if (sizeBytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(sizeBytes / 1024))} KB`;
  }

  return `${(sizeBytes / 1024 / 1024).toFixed(1)} MB`;
}
